// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-table[data-v-43313d40] {\n  height: 25vh;\n}", ""]);
// Exports
module.exports = exports;
